import React, { useCallback, useEffect, useState } from "react";
import { Button, MessageBanner, Modal, ModalFooter, RadioButton, RadioButtonGroup, TextArea, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { EXCLUSION_REASONS } from "../../types/enforcement";
export var BulkExcludePeriodicalsDialog = function (_a) {
    var open = _a.open, selectedCount = _a.selectedCount, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useState(""), reason = _c[0], setReason = _c[1];
    var _d = useState(""), note = _d[0], setNote = _d[1];
    useEffect(function () {
        if (!open) {
            setReason("");
            setNote("");
        }
    }, [open]);
    var isOtherReason = reason === "OTHER";
    var isValid = selectedCount > 0 &&
        reason !== "" &&
        (!isOtherReason || note.trim().length > 0);
    var handleSubmit = useCallback(function () {
        if (reason) {
            onSubmit(reason, note);
        }
    }, [reason, note, onSubmit]);
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.periodicals.bulk.exclude.title",
        }), onClose: onClose, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !isValid || isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: onClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.bulk.exclude.summary", values: { count: selectedCount } })),
        React.createElement(RadioButtonGroup, { label: formatMessage({
                id: "ui-br-legaldeposits.enforcement.exclude.reasonLabel",
            }), value: reason, onChange: function (e) {
                return setReason(e.target.value);
            } }, EXCLUSION_REASONS.map(function (opt) { return (React.createElement(RadioButton, { key: opt.value, label: formatMessage({ id: opt.labelId }), value: opt.value })); })),
        isOtherReason && (React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-legaldeposits.enforcement.exclude.noteLabel",
            }), value: note, onChange: function (e) {
                return setNote(e.target.value);
            }, required: true }))));
};
